export const WORKLOCATIONTYPE_OFFICE_STRING = "Office";
export const WORKLOCATIONTYPE_REMOTE_STRING = "Remote";
export const WORKLOCATIONTYPE_TIMEOFF_STRING = "TimeOff";
export const WORKLOCATIONTYPE_NONE_STRING = "None";
export const WORKLOCATIONTYPE_UNSPECIFIED_STRING = "Unspecified";
